import React from "react";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
import { PolicySelectorField } from "../PolicySelector";
export const InsightsPermission = () => {
    const intl = useIntl();
    const policyOptions = [
        {
            value: ["insights_access" /* PolicyActions.INSIGHTS_ACCESS */],
            label: intl.formatMessage(messages.insightsPermissionOptionView),
        },
        {
            value: [],
            label: intl.formatMessage(messages.insightsPermissionOptionDeny),
        },
    ];
    return (React.createElement(PolicySelectorField, { label: intl.formatMessage(messages.insightsPermissionLabel), policyOptions: policyOptions, id: "allow.insights" }));
};
export default InsightsPermission;
